import React, { useState, useEffect } from 'react';
import { Button, Row, Col, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import { MultiSelect } from "primereact/multiselect";
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import './AutoEmail.css';

const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;
//const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL_SAROJ || 'http://127.0.0.1:8000/';
function AutoEmail() {
    const [showAssignGroup, setShowAssignGroup] = useState(false);
    const [emailGroups, setEmailGroups] = useState([]);
    const [emailList, setEmailList] = useState([]);
    const [newEmail, setNewEmail] = useState('');
    const [error, setError] = useState('');
    const [autoEmailError, setAutoEmailError] = useState('');
    const [groupError, setGroupError] = useState('');
    const [selectedGroupId, setSelectedGroupId] = useState('');
    const [newGroupName, setNewGroupName] = useState('');
    const [autoEmail, setAutoEmail] = useState(null);
    const [sendAlert, setSendAlert] = useState(null);
    const [selectedGroupIds, setSelectedGroupIds] = useState([]);

    const validateEmail = (email) => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email.trim());
    };

    const handleAddEmail = () => {
        if (newEmail.trim() && validateEmail(newEmail)) {
            setEmailList([...emailList, newEmail.trim()]);
            setNewEmail('');
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddEmail();
        }
    };

    const fetchGroupData = async () => {
        try {
            const response = await fetch(`${backendUrl}AutoEmail/auto_email_user_groups/`);
            const result = await response.json();
            setEmailGroups(result.groups);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };

    useEffect(() => {
        fetchGroupData();
    }, []);

    const handleAutoEmailSubmit = async (e) => {
        e.preventDefault();
        setAutoEmailError('');
        setGroupError('');

        if (!autoEmail) {
            setAutoEmailError("Please select Auto Email option.");
            return;
        }
        if (!sendAlert) {
            setAutoEmailError("Please select Send Alert option.");
            return;
        }
        if (!selectedGroupIds || selectedGroupIds.length === 0) {
            setGroupError("Please select at least one User Group.");
            return;
        }

        const payload = {
            set_auto: autoEmail,
            send_alert: sendAlert,
            group_ids: selectedGroupIds,
        };

        try {
            const response = await axios.post(
                `${backendUrl}AutoEmail/save_auto_email_settings/`,
                payload,
                { headers: { "Content-Type": "application/json" } }
            );

            if (response.status === 200 || response.status === 201) {
                alert(response.data.status || "Auto Email settings saved!");
            }
        } catch (error) {
            console.error("Error saving auto email settings:", error);
            setAutoEmailError("Something went wrong while saving Auto Email settings.");
        }
    };

    const handleGroupSave = async () => {
        setError('');
        // Automatically add newEmail to emailList if it's valid
        let updatedEmailList = [...emailList];
        if (newEmail.trim()) {
            if (validateEmail(newEmail.trim())) {
                updatedEmailList.push(newEmail.trim());
            } else {
                setError(`Invalid email: ${newEmail}`);
                return;
            }
        }

        if ((!selectedGroupId && !newGroupName) || (selectedGroupId && newGroupName)) {
            setError("Please select either an existing group or enter a new group name.");
            return;
        }

        if (!emailList.length) {
            setError("Please enter at least one valid email.");
            return;
        }

        const invalidEmails = emailList.filter(email => !validateEmail(email));
        if (invalidEmails.length > 0) {
            setError(`Invalid email(s): ${invalidEmails.join(', ')}`);
            return;
        }

        // ✅ Validation: check duplicate group name
        if (newGroupName) {
            const duplicate = emailGroups.some(
                g => g.group_name.toLowerCase() === newGroupName.toLowerCase()
            );
            if (duplicate) {
                setError(`Group "${newGroupName}" already exists. Please choose another name.`);
                return;
            }
        }


        const payload = {
            assign_group_names: selectedGroupId || null,
            group_name: newGroupName || null,
            emails: emailList,
            group_ids: selectedGroupIds.length > 0 ? selectedGroupIds : null,
        };

        try {
            const response = await axios.post(
                `${backendUrl}AutoEmail/save_auto_email_user_group/`,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );

            if (response.status === 200 || response.status === 201) {
                alert(response.data.status || "Group saved!");
                fetchGroupData();
                setSelectedGroupId('');
                setNewGroupName('');
                setEmailList([]);
                setNewEmail('');
                setError('');
                setShowAssignGroup(false);
            }
        } catch (error) {
            console.error('There was an error!', error);
            setError("Something went wrong while saving the group.");
        }
    };
    const handleExistingGroupChange = async (groupId) => {
        setSelectedGroupId(groupId);
        if (groupId) {
            setNewGroupName('');
            try {
                const response = await axios.get(`${backendUrl}AutoEmail/get-group-emails/${groupId}/`);
                setEmailList(response.data.emails);
            } catch (err) {
                console.error("Error fetching group emails", err);
                setEmailList([]);
            }
        } else {
            setEmailList([]);
            setNewEmail('');
        }
    };

    const handleNewGroupNameChange = (e) => {
        setNewGroupName(e.target.value);
        if (e.target.value && selectedGroupId) {
            setSelectedGroupId('');
            setEmailList([]);
            setNewEmail('');
        }
    };

    return (
        <div className=" bg-light d-flex align-items-center justify-content-center">
            <div className="bg-white rounded-lg shadow border" style={{ width: '100%', padding: '20px', height: '680px' }}>
                <div className="text-center">
                    <div className="d-flex align-items-center justify-content-center gap-3" style={{ marginBottom: '20px' }}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="#6c757d"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        >
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                            <path d="M7 8l5 4 5-4" />
                            <path d="M7 12v4h10v-4" />
                        </svg>
                        <h1 className="fs-4 text-dark" style={{ marginTop: '5px' }}>Auto Email Setup</h1>
                    </div>
                </div>

                <Row className="g-5">
                    <Col lg={6}>
                        <div className="space-y-5 p-4">
                            <Form onSubmit={handleAutoEmailSubmit}>
                                <Form.Group className="mb-4">
                                    <Form.Label className="fw-medium text-muted fs-6">Set Auto Email</Form.Label>
                                    <div className="d-flex gap-4">
                                        <Form.Check
                                            type="radio"
                                            label="Yes"
                                            checked={autoEmail === "yes"}
                                            onChange={() => setAutoEmail("yes")}
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="No"
                                            checked={autoEmail === "no"}
                                            onChange={() => setAutoEmail("no")}
                                        />
                                    </div>
                                    
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label className="fw-medium text-muted fs-6">Send alert for Area of Interest</Form.Label>
                                    <div className="d-flex gap-4">
                                        <Form.Check
                                            type="radio"
                                            label="Yes"
                                            checked={sendAlert === "yes"}
                                            onChange={() => setSendAlert("yes")}
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="No"
                                            checked={sendAlert === "no"}
                                            onChange={() => setSendAlert("no")}
                                        />
                                    </div>
                                    
                                </Form.Group>

                                <Form.Group className="mb-4">
                                    <Form.Label className="fw-medium text-muted fs-6">User Group</Form.Label>
                                    <div className="d-flex gap-2">
                                        <MultiSelect
                                            value={selectedGroupIds}
                                            options={emailGroups}
                                            onChange={(e) => setSelectedGroupIds(e.value)}
                                            optionLabel="group_name"
                                            optionValue="id"
                                            placeholder="Select User Groups"
                                            display="chip"
                                            className="w-100"
                                        />
                                        <Button
                                            onClick={() => setShowAssignGroup(!showAssignGroup)}
                                            variant="info"
                                            className="text-white"
                                            style={{ width: '300px' }}
                                        >
                                            Assign User Group
                                        </Button>
                                    </div>
                                    
                                </Form.Group>
                                {autoEmailError && (<div className="text-danger small mb-2">{autoEmailError}</div>)}
                                {groupError && ( <div className="text-danger small mb-2">{groupError}</div> )}

                                <Button type="submit" variant="primary" className="w-100 py-2">
                                    Submit
                                </Button>
                            </Form>
                        </div>
                    </Col>

                    <Col lg={6}>
                        <div className={`transition-all duration-300 ${showAssignGroup ? 'opacity-100' : 'opacity-50 pointer-events-none'}`}>
                            <div className="border rounded p-4 bg-light">
                                <h3 className="fs-5 fw-medium text-dark mb-4">Assign Group</h3>
                                <Form onSubmit={(e) => { e.preventDefault(); handleGroupSave(); }}>
                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-medium text-muted">Exist Group Name:</Form.Label>
                                        <Form.Select value={selectedGroupId} onChange={(e) => handleExistingGroupChange(e.target.value)}>
                                            <option value="">-- Select --</option>
                                            {emailGroups.map((group) => (
                                                <option key={group.id} value={group.id}>
                                                    {group.group_name}
                                                </option>
                                            ))}
                                        </Form.Select>
                                    </Form.Group>

                                    <div className="text-center text-muted fw-medium mb-3">OR</div>

                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-medium text-muted">New Group Name:</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={newGroupName}
                                            onChange={handleNewGroupNameChange}
                                            placeholder="Enter a group name"
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-3">
                                        <Form.Label className="fw-medium text-muted">Email(s):</Form.Label>
                                        <div
                                            className="border rounded p-2 d-flex flex-wrap align-items-start bg-white"
                                            style={{ minHeight: '120px' }}
                                        >
                                            {emailList.length > 0 && (
                                                <div className="d-flex flex-wrap gap-2 mb-2">
                                                    {emailList.map((email, index) => (
                                                        <div
                                                            key={index}
                                                            className="bg-secondary text-dark px-3 py-1 rounded-pill d-flex align-items-center gap-2"
                                                            style={{ fontSize: '0.75rem' }}
                                                        >
                                                            {email}
                                                            <span
                                                                onClick={() => setEmailList(emailList.filter((_, i) => i !== index))}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    color: '#555',
                                                                }}
                                                            >
                                                                ×
                                                            </span>
                                                        </div>
                                                    ))}
                                                </div>
                                            )}
                                            <Form.Control
                                                value={newEmail}
                                                onChange={(e) => setNewEmail(e.target.value)}
                                                onKeyPress={handleKeyPress}
                                                placeholder="Add email address..."
                                                className="border-0 bg-transparent p-0"
                                                style={{ fontSize: '0.875rem' }}
                                            />
                                            {emailList.length === 0 && (
                                                <p className="text-muted small fst-italic mb-0">
                                                    No emails added yet. Type an email address above.
                                                </p>
                                            )}
                                            {selectedGroupId && emailList.length > 0 && (
                                                <p className="text-muted small fst-italic mb-0">
                                                    {/* Editing emails for: {emailGroups.find(g => g.id === selectedGroupId)?.group_name} */}
                                                </p>
                                            )}
                                        </div>
                                    </Form.Group>

                                    {error && <p className="text-danger small mb-3">{error}</p>}

                                    <Button type="submit" variant="primary" className="w-100">
                                        Save
                                    </Button>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default AutoEmail;